import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { tv as s } from "tailwind-variants";
import { I as c } from "./chunks/index-CgDhSQ6a.js";
const a = s({
  slots: {
    wrapper: ["isolate", "relative", "overflow-hidden"],
    background: [
      "absolute",
      "bg-center",
      "bg-no-repeat",
      "h-full",
      "left-0",
      "opacity-30",
      "top-0",
      "w-full",
      "z-[-2]",
      "[background-image:theme(backgroundImage.patternBracket),theme(backgroundImage.patternDots),theme(backgroundImage.patternSquiggle)]",
      "[background-position:top_10%_left_10%,top_20%_right_0,bottom_15%_right_10%,bottom_0_left_-4rem]",
      "mobile:[background-image:theme(backgroundImage.patternBracket),theme(backgroundImage.patternDots),theme(backgroundImage.patternSquiggle),theme(backgroundImage.patternCircle)]"
    ]
  },
  variants: {
    hasImage: {
      true: {
        background: [
          "[background-color:hsla(0,0%,0%,0.80)]",
          "bg-blend-darken",
          "opacity-100"
        ]
      }
    }
  }
}), { wrapper: g, background: m } = a(), i = ({
  className: r,
  children: o,
  image: e,
  tagName: l = "div"
}) => /* @__PURE__ */ n(l, { className: g({ class: r }), children: [
  /* @__PURE__ */ t("div", { className: m({ hasImage: !!e }) }),
  e && /* @__PURE__ */ t("div", { className: "absolute h-full left-1/2 max-w-[theme(containerWidth.lg)] top-[20%] -translate-x-1/2 w-[70vw] z-[-1]", children: /* @__PURE__ */ t(
    c,
    {
      alt: "",
      className: "brightness-[0.20] object-cover object-top",
      fill: !0,
      priority: !0,
      src: e,
      width: 900
    }
  ) }),
  o
] });
i.styles = a;
export {
  i as default
};
